import { memo, useMemo, useEffect, useState } from 'react';
import styles from './detail.module.scss';
import { DetailSellProps } from '../../../interfaces/salePost';
import { OpenModalProps } from "../../../interfaces/components";
import { useNavigate, useLocation } from "react-router-dom";
import { caracteristics, conforts as confortsImages, images } from '../../../constants/images';
import { MODAL_SELL_TEXTS } from "../../../constants/offers";
import ButtonShared from '../../../components/Button';
import Button from '../../../components/Button';
import Modal from "../../../components/Modal";
import PublicationDetailRefactored from '../../../components/PublicationDetail/PublicationDetailRefactored';
import { useToast } from '../../../helpers/hooks';
import { capitalize } from '../../../helpers/app';
import { useAuthModal } from '../../../context/AuthModalContext';
import { AnalyticsService } from '../../../helpers/analytics';
import { trackEvent } from '../../../config/firebase';
import SuggestedPrices from '../../../components/SuggestedPrices';
import IcarReportModal from '../../../containers/Sell/IcarReportModalContainer';

const Detail = ({
    user,
    salePost,
    clearPostFetching,
    clearSalePost,
    postPublication,
    setLoginRedirection,
    selectedAdditionalCharacters
}: DetailSellProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    const location = useLocation();
    const { handleOpenAuthModal } = useAuthModal();
    const [loading, setLoading] = useState<boolean>(false);
    const [openModal, setOpenModal] = useState<OpenModalProps>({ open: false, type: "accepted" });
    const [timeOutMessage, setTimeOutMessage] = useState<any>({ open: false, text: "" });

    const handlePressBack = () => {
        localStorage.setItem('linzeReturnFromDetail', 'true');
        navigate('/vender-auto/pasos');
    };

    const handlePressPublish = () => {
        if (!user) {
            toast("Debes iniciar sesión para publicar tu auto");
            handleOpenAuthModal();
            return;
        }
        trackEvent("venta-boton-publicar");
        setLoading(true);
        AnalyticsService.trackPublishCar(publicationNormalized);
        postPublication();
        onCloseModal();
    }

    const onCloseModal = () => {
        clearPostFetching();
        if (salePost?.fetchingPostPublication === "failure") {
            return setOpenModal({ ...openModal, open: false });
        }
        setOpenModal({ ...openModal, open: false });
        clearSalePost();
        navigate("agradecimiento/venta", {
            state: {
                title: "Estás a solo un paso de vender tu auto. ",
                text: "Estamos revisando la información de tu vehículo. Te avisaremos cuando ya esté publicado.",
                buttonText: "Consultar publicación",
                publication: salePost,
            }
        });
    };

    const publicationNormalized: any = useMemo(() => {
        const conforts = salePost?.confort && salePost?.confort.map((item: any) => (
            {
                name: item?.label,
                value: item?.isSelected ? "Si" : "No",
                icon: confortsImages[item?.id] ?? ""
            }
        ));
        let publicationObject = {
            pictures: salePost?.imagesVideos.filter((image: any) => image.uri ?? image.url ?? image.previewURL ?? image),
            title: `${salePost.brands.selected?.label} ${salePost.models.selected?.label}`,
            year: salePost?.years.selected,
            mileage: salePost?.kms,
            region: salePost?.region,
            price: salePost?.price,
            condition: salePost?.condition,
            chatgpt_description: salePost?.price?.descriptionGPT?.data,
            confort: conforts,
            tags: salePost?.tags,
            record: salePost?.record,
            additional_characters: selectedAdditionalCharacters,
            detail: {
                ...salePost?.record,
                negotiate: salePost?.negotiatePrice,
                bonus_info: {
                    bonus: salePost?.financingBonus,
                    value: 0
                },
                negotiate_percent: salePost?.negotiatePercentage
            },
            percentage: salePost?.negotiatePercentage,
            version: (salePost?.version?.id !== 0 && salePost?.version?.id !== 1) ? salePost?.version?.name : null,
            suggested_prices: salePost?.suggestedPrices,
            vehicle_data: salePost?.vehicle_data,
            caracteristics: [
                {
                    name: "Modelo",
                    value: salePost.models.selected?.label,
                    icon: caracteristics.model
                },
                {
                    name: "Año",
                    value: salePost?.years.selected,
                    icon: caracteristics.year
                },
                {
                    name: "Versión",
                    value: salePost?.version?.name,
                    icon: caracteristics.version
                },
                {
                    name: "Color",
                    value: capitalize(salePost?.color),
                    icon: caracteristics.color
                },
                {
                    name: "Combustible",
                    value: capitalize(salePost?.fuel),
                    icon: caracteristics.fuel
                },
                {
                    name: "Puertas",
                    value: salePost?.doors,
                    icon: caracteristics.door
                },
                {
                    name: "Transmisión",
                    value: capitalize(salePost?.transmission),
                    icon: caracteristics.transmission
                },
                {
                    name: "Carrocería",
                    value: capitalize(salePost?.vehicle_type),
                    icon: caracteristics.type
                }
            ],
            records: [
                {
                    key: "accidents_reported",
                    name: "Accidentes reportados",
                    value: salePost?.record?.accidentsReported ? "Con accidentes reportados" : "Sin accidentes reportados",
                    icon: caracteristics.accidents
                },
                {
                    key: "personal_use",
                    name: "Uso personal",
                    value: salePost?.record?.personalUse ? "Vehículo de uso personal" : "Vehículo de uso comercial",
                    icon: caracteristics.usage
                },
                {
                    key: "sole_owner",
                    name: "Dueño único",
                    value: salePost?.record?.soleOwner ? "Único dueño" : "Multiples dueños",
                    icon: caracteristics.accountant
                }
            ]
        }
        return publicationObject;
    }, [salePost]);

    useEffect(() => {
        if (!salePost?.plate) {
            navigate("/vender-auto");
        }
        trackEvent("venta-paso-preview-final");
    }, []);

    return (
        <div className={styles.container}>
            <Modal open={openModal.open} onClose={onCloseModal} variant='white'>
                <div className={styles.modalPublicationContainer}>
                    {["accepted", "pending"].includes(openModal?.type) && <img alt="success" title="success" src={images.purpleRoundCheckmark} width={120} />}
                    <p className={styles.title}>{MODAL_SELL_TEXTS[openModal.type].title}</p>
                    <p className={styles.description}>{MODAL_SELL_TEXTS[openModal.type].description}</p>
                    <Button onPress={onCloseModal} title={MODAL_SELL_TEXTS[openModal.type].button} primary />
                </div>
            </Modal>
            <PublicationDetailRefactored
                type="salePost"
                publication={publicationNormalized}
                logoDealerships={salePost?.data?.branch_data?.picture}
                vehicleTypeSelected="used"
                clickFavorite={() => {}}
                loading={loading}
                onLinzeCheckClick={() => {}}
                onAutoFinClick={() => {}}
            >
                {
                    <div className={styles.buttonContainer}>
                        <ButtonShared
                            onPress={handlePressBack}
                            title="Volver a editar"
                            tertiary
                            className={styles.back}
                            disabled={loading}
                            size="small"
                        />
                        <ButtonShared
                            size="small"
                            onPress={handlePressPublish}
                            title="Publicar"
                            primary
                            className={styles.publish}
                            loading={loading}
                        />
                    </div>
                }
                <div className={`${styles.timeOut} ${timeOutMessage?.open && styles.show}`}>
                    <p className={styles.loader}>
                        {timeOutMessage?.text}
                        <span className={styles.dotOne}>.</span>
                        <span className={styles.dotTwo}>.</span>
                        <span className={styles.dotThree}>.</span>
                    </p>
                </div>
            </PublicationDetailRefactored>
        </div>
    )
}

export default memo(Detail);
